import { ApiClient } from '@/api/client';

const client = new ApiClient('/api/v1/pages');

export default {
  /**
   * Get Google Analytics for a Page
   */
  getPageGoogleAnalytics: (pageId, queryParams = {}) =>
    client.get(`${pageId}/google-analytics`, { params: queryParams }),
};
